import styles from "./EmptyBasketCart.module.scss";
import emptyBasketCart from "@/assets/img/emptyBasketCart.svg";
import { Button } from "@/components/Button";
import { useNavigate } from "react-router";

export const EmptyBasketCart = () => {
  const navigate = useNavigate()

  const handlePressButton = () => {
    navigate('/')
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.emptyBasketCart}>
        <img src={emptyBasketCart} alt="emptyBasketCart" />

        <div className={styles.textWrapper}>
          <p className={styles.emptyBasketCartTitle}>
            Ой, ваша корзина пуста!
          </p>
          <p className={styles.emptyBasketCartDescription}>
            Выбрать корт можно в разделе "Аренда", а тренировки и аренда ракеток находятся в разделе "Сервис"
          </p>
        </div>

        <Button
          onClickFunc={handlePressButton}
        >
          Арендовать корт
        </Button>
      </div>
    </div>
  )
}